import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface LoadingSkeletonProps {
  title?: boolean;
  filter?: boolean;
  table?: boolean;
}

export const LoadingSkeleton = ({ 
  title = true, 
  filter = true, 
  table = true 
}: LoadingSkeletonProps = {}) => (
  <Box sx={{ p: 3 }}>
    {/* Título */}
    {title && (
      <Skeleton variant="text" width={200} height={40} sx={{ mb: 4 }} />
    )}

    {/* Área de filtro */}
    {filter && (
      <Skeleton variant="rectangular" height={100} sx={{ mb: 2, borderRadius: 1 }} />
    )}

    {/* Tabela */}
    {table && (
      <Skeleton variant="rectangular" height={400} sx={{ borderRadius: 1 }} />
    )}
  </Box>
); 